// extracted by mini-css-extract-plugin
export default {"wrapper":"Email_wrapper__B5sPt","contents":"Email_contents__DlrFN"};